import { render, staticRenderFns } from "./CartItemCard.vue?vue&type=template&id=39281ef4&"
import script from "./CartItemCard.vue?vue&type=script&lang=js&"
export * from "./CartItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports